/* eslint-disable react/no-array-index-key */
import React from 'react';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import { IProjectSourcesPeriod } from 'views/ProFormaTable/types';
import RenderIf from 'components/RenderIf/RenderIf';
import { useProFormaSocketContext } from '../../../socketContext/ProFormaSocketProvider';
import { getSourcesPeriodDisplayValue } from '../helpers';
import PeriodCellValue from '../../DevelopmentUsesTable/PeriodCellValue/PeriodCellValue';

export interface IProjectActualsSourceGrandTotalRowProps {
    sourcesPeriods: IProjectSourcesPeriod[];
    projectHasSources: boolean;
}

const ProjectActualsSourceGrandTotalRow = ({ sourcesPeriods, projectHasSources }: IProjectActualsSourceGrandTotalRowProps) => {
    const { showCents, periodCadence } = useProFormaSocketContext();
    const showCentsFormat = showCents ? '$0,0.00' : '$0,0';

    const inCurrentPeriodIndex = sourcesPeriods.findIndex(period => period.inCurrentPeriod);

    return (
        <tr className="NSTable__tfoot__tr" key={`${periodCadence}-grandTotalRow`}>
            <td className="NSTable__tfoot__tr__td text-left">
                Grand total
            </td>
            <td className="NSTable__tfoot__tr__td" />
            <td className="NSTable__tfoot__tr__td" />
            <td className="NSTable__tfoot__tr__td" />
            <td className="NSTable__tfoot__tr__td text-right text-nowrap">
                {projectHasSources && sourcesPeriods[1] ? numeralFormatterCurrency(sourcesPeriods[1].totalSourceAmount || 0, showCentsFormat) : ''}
            </td>
            <td className="NSTable__tfoot__tr__td" />

            <RenderIf isTrue={projectHasSources}>
                {sourcesPeriods.map(period => {
                    const periodIndex = sourcesPeriods.indexOf(period);
                    const isFutureTimeline = new Date(period.periodStartDate) > new Date();

                    const periodDisplayValue = getSourcesPeriodDisplayValue(
                        period.totalAmountFunded, period.totalAmountToFund, periodIndex, inCurrentPeriodIndex, isFutureTimeline,
                    );

                    const cellKey = `${periodCadence}-grandTotal-${period.periodName}-${period.periodStartDate}`;

                    return (
                        <PeriodCellValue
                            key={cellKey}
                            tooltipId={cellKey}
                            period={{ label: period?.periodName, value: period?.periodName }}
                            value={numeralFormatterCurrency(periodDisplayValue, showCentsFormat)}
                            cellClassName="NSTable__tbody__tr__td text-dark text-right"
                        />
                    );
                })}
            </RenderIf>

            <RenderIf isTrue={!projectHasSources}>
                <td className="NSTable__tfoot__tr__td">
                    <div className="NSTable__thead__tr__td--opacity-3" />
                </td>
            </RenderIf>
        </tr>
    );
};

export default ProjectActualsSourceGrandTotalRow;
